import { Select } from '@fourthwall/components';
import React from 'react';
import { FormFields, } from '../../hooks/useBadgeForm/types';
import { RuleLayout } from '../RuleLayout';
export const TierRule = ({ form, options, tiers, rule }) => (React.createElement(RuleLayout, { top: React.createElement(Select, { value: 'Tier', label: "Requirement to earn badge", options: options, onValueChange: (value) => {
            const newRules = form.values.rules.map((formRule) => formRule === rule ? { type: value } : formRule);
            form.setFieldValue(FormFields.rules, newRules);
        } }), bottom: React.createElement(Select, { label: "Tier", options: tiers, value: rule.tierId?.toString(), onValueChange: (value) => {
            const newRules = form.values.rules.map((formRule) => formRule === rule
                ? {
                    type: 'Tier',
                    tierId: parseInt(value),
                }
                : formRule);
            form.setFieldValue(FormFields.rules, newRules);
        } }), onRemove: () => {
        form.setFieldValue(FormFields.rules, form.values.rules.filter((formRule) => formRule !== rule));
    } }));
